import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'compound'),
  es: flattenMessages(es, 'compound'),
  ru: flattenMessages(ru, 'compound'),
  zh: flattenMessages(zh, 'compound'),
};
